import { BoughtService, QuoteReservation } from '@/models/quote.ts'
import { toApiBoughtServices } from '@/utils/timeSchedules'

interface GetReservationsObjectProps {
  reservations: QuoteReservation[]
  isQuoteForTickets?: boolean
}

// if the reservation is for a specific spot
// the object needs to have a key following this pattern: “_” + spotType + “_” + spotName
// if the reservation is for a generic ticket, an index number will suffice
export const getReservationsObjectFrom = (
  props: GetReservationsObjectProps
) => {
  return props.reservations.reduce<Record<string, object>>(
    (acc, reservation, index) => {
      const dynamicKey = props.isQuoteForTickets
        ? index
        : `_${reservation.spotType}_${reservation.spotName}`

      const boughtServices: BoughtService[] = Object.values(
        reservation.boughtServices
      )
        .map((boughtServices) => Object.values(boughtServices))
        .flat()

      return {
        ...acc,
        [dynamicKey]: {
          ...reservation,
          boughtServices: toApiBoughtServices(boughtServices),
        },
      }
    },
    {}
  )
}
